/**
 * Starts a download of a URL the server just returned (e.g. a signed export link).
 *
 * window.open() after an await is no longer a user gesture, so Chrome's popup
 * blocker silently drops it. A programmatic link click is treated as a download,
 * not a popup, and works without a gesture.
 */
export function startDownload(url: string, fileName?: string): void {
  const a = document.createElement("a");
  a.href = url;
  if (fileName) a.download = fileName;
  a.rel = "noopener";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
}
